import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";
import { FileRole } from "@remi/types/file";

export const PendingEstimateAssetsTaskAttemptSchema = z.object({
  type: z.literal(TaskType.PENDING_ESTIMATE_ASSETS),
  fileId: z.string(),
  fileRole: z.enum([FileRole.HOVER_ESX, FileRole.EAGLEVIEW_ESX]),
});

export const PendingEstimateAssetsTaskAttemptDatabaseSchema = z.object({
  type: z.literal(TaskType.PENDING_ESTIMATE_ASSETS),
  fileId: z.string().optional(),
  fileRole: z.enum([FileRole.HOVER_ESX, FileRole.EAGLEVIEW_ESX]).optional(),
});
